import { createModel } from 'xstate/lib/model';

import baseEvents from 'common/bento/config/baseEvents';

import { ComplianceModuleDataQuery } from '../graphql/queries/complianceModuleData.gql';
import { FormResult } from '../pages/ComplianceForm/components/Form';
import { TaxResidencySchema } from '../pages/TaxResidencies/TaxResidencies';

/**
 * We have to remap company to make it optional
 * @see https://github.com/dotansimha/graphql-code-generator/issues/8461
 */
type ComplianceModuleData = {
  viewer: Omit<ComplianceModuleDataQuery['viewer'], 'company'> & {
    company: ComplianceModuleDataQuery['viewer']['company'] | null;
  };
};

export type Context = {
  getModuleData: () => ComplianceModuleData;
};

const initialContext: Context = {
  getModuleData: () => {
    throw new Error('NOT_IMPLEMENTED');
  },
};

const creators = {
  events: {
    ...baseEvents,
    SAVE_TAX_RESIDENCIES: (data: TaxResidencySchema[]) => ({ data }),
    SUBMIT: (data: FormResult) => ({ data }),
  },
};

const model = createModel(initialContext, creators);

export default model;

export type Model = typeof model;
